import React, { Component, cloneElement } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const Events = {
  enter: "enter",
  leave: "leave",
  click: "click",
  clickOutside: "click-outside",
  manual: "manual"
};

export default class Popover extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    content: PropTypes.any,
    position: PropTypes.oneOf(["top", "bottom", "left", "right"]),
    show: PropTypes.oneOf([Events.enter, Events.click, Events.manual]),
    hide: PropTypes.oneOf([
      Events.leave,
      Events.click,
      Events.clickOutside,
      Events.manual
    ]),
    margin: PropTypes.number,
    zIndex: PropTypes.number
  };
  static defaultProps = {
    position: "top",
    show: "enter",
    hide: "leave",
    margin: 18,
    zIndex: 1
  };
  state = { isShowing: false, rect: { x: 0, y: 0, width: 0, height: 0 } };

  render() {
    const { children, content, position, show, hide, margin, zIndex} = this.props;
    const { isShowing, rect } = this.state;
    return [
      cloneElement(children, {
        key: children.key || "popover",
        onTouchStart: this.onTouchStart,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onClick: this.onClick
      }),
      isShowing &&
        ReactDOM.createPortal(
          <Block rect={rect} show={show} hide={hide} zIndex={zIndex} >
            <Position
              innerRef={ref => (this.node = ref)}
              position={position}
              margin={margin}
              hide={hide}
            >
              {content}
            </Position>
          </Block>,
          document.body
        )
    ];
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateDimensions);
    document.removeEventListener("click", this.handleOutside);
  };

  updateDimensions = () => {
    this.setState({ rect: ReactDOM.findDOMNode(this).getBoundingClientRect() });
  };

  show = () => {
    if (!this.state.isShowing) {
      document.addEventListener("click", this.handleOutside);
      this.updateDimensions();
      this.setState({ isShowing: true });
    }
  };

  hide = () => {
    if (this.state.isShowing) {
      document.removeEventListener("click", this.handleOutside);
      this.setState({ isShowing: false });
    }
  };

  onTouchStart = () => {
    if (!this.state.isShowing && this.props.show === Events.enter) this.show();
    const props = this.props.children.props;
    if (props.onTouchStart) props.onTouchStart();
  };

  onMouseEnter = () => {
    if (!this.state.isShowing && this.props.show === Events.enter) this.show();
    const props = this.props.children.props;
    if (props.onMouseEnter) props.onMouseEnter();
  };

  onMouseLeave = () => {
    if (this.state.isShowing && this.props.hide === Events.leave) this.hide();
    const props = this.props.children.props;
    if (props.onMouseLeave) props.onMouseLeave();
  };

  onClick = () => {
    if (!this.state.isShowing && this.props.show === Events.click) {
      this.show();
    }
    const props = this.props.children.props;
    if (props.onClick) props.onClick();
  };

  handleOutside = e => {
    if (
      this.props.hide === Events.manual ||
      (this.props.hide === Events.clickOutside && this.node.contains(e.target))
    ) {
      return;
    }
    this.hide();
  };
}

const Block = styled.div`
  position: absolute;
  display: inline-block;
  pointer-events: none;
  ${props => css`
    left: ${props.rect.left}px;
    top: ${props.rect.top}px;
    width: ${props.rect.width}px;
    height: ${props.rect.height}px;
    z-index: ${props.zIndex};
  `};
`;

const Position = styled.div`
  position: absolute;
  pointer-events: ${props => (props.hide === Events.leave ? "none" : "auto")};
  ${props => {
    switch (props.position) {
      case "left":
        return css`
          right: 100%;
          top: 50%;
          transform: translate(-${props.margin}px, -50%);
        `;
      case "right":
        return css`
          left: 100%;
          top: 50%;
          transform: translate(${props.margin}px, -50%);
        `;
      case "bottom":
        return css`
          top: 100%;
          left: 50%;
          transform: translate(-50%, ${props.margin}px);
        `;
      case "top":
      default:
        return css`
          bottom: 100%;
          left: 50%;
          transform: translate(-50%, -${props.margin}px);
        `;
    }
  }};
`;



// WEBPACK FOOTER //
// ./src/module-common/Popover.js